import React from "react";
import { MEDIA_PAGE_SIZE_OPTIONS } from "./mediaLibraryPagination";

/**
 * Compact page-size control for Media Library grids — [24 ▼]
 */
const MediaLibraryPageSizeSelect = ({ value, onChange, className = "" }) => (
  <label className={`xc-ml-page-size ${className}`.trim()}>
    <select
      className="xc-ml-page-size__select"
      value={value}
      onChange={(e) => onChange(Number(e.target.value))}
      aria-label="Items per page"
    >
      {MEDIA_PAGE_SIZE_OPTIONS.map((size) => (
        <option key={size} value={size}>
          {size}
        </option>
      ))}
    </select>
    <i className="ri-arrow-down-s-line xc-ml-page-size__icon" aria-hidden="true" />
  </label>
);

export default MediaLibraryPageSizeSelect;
